// (A) 중립 Table API — antd 미접촉. (B) HeadlessTable(@tanstack/react-table core)에 위임.
import type { CSSProperties, Key, ReactNode } from 'react'
import { HeadlessTable } from '../_impl/HeadlessTable'

/** antd ColumnType 계승(실측 ngql 컬럼 키). 커스텀 키는 인덱스 시그니처로 통과. */
export interface OmwTableColumn<T> {
  dataIndex?: string | string[]
  key?: string
  title?: ReactNode
  width?: number | string
  align?: 'left' | 'center' | 'right'
  className?: string
  render?: (value: unknown, record: T, index: number) => ReactNode
  [extra: string]: unknown
}

/** antd rowSelection 계승(실측: 체크박스 선택). */
export interface OmwTableRowSelection<T> {
  type?: 'checkbox' | 'radio'
  selectedRowKeys?: Key[]
  onChange?: (selectedRowKeys: Key[], selectedRows: T[]) => void
  getCheckboxProps?: (record: T) => { disabled?: boolean }
}

/** antd pagination 계승(실측: getPaginationInfo() 반환). */
export interface OmwTablePagination {
  current?: number
  pageSize?: number
  total?: number
  onChange?: (page: number, pageSize: number) => void
  showSizeChanger?: boolean
  pageSizeOptions?: number[]
  hideOnSinglePage?: boolean
}

/** onRow 반환(실측: ngql getTableOnRow). */
export interface OmwTableRowHandlers {
  onClick?: (e: React.MouseEvent) => void
  onMouseEnter?: (e: React.MouseEvent) => void
  onMouseLeave?: (e: React.MouseEvent) => void
  onMouseDown?: (e: React.MouseEvent) => void
}

export interface OmwTableProps<T> {
  columns: OmwTableColumn<T>[]
  dataSource: T[]
  rowKey: string | ((record: T) => Key)
  loading?: boolean
  onRow?: (record: T, index: number) => OmwTableRowHandlers
  rowClassName?: (record: T, index: number) => string
  rowSelection?: OmwTableRowSelection<T>
  pagination?: OmwTablePagination | false
  onChange?: (
    pagination: OmwTablePagination,
    filters: Record<string, unknown[]>,
    sorter: unknown,
    extra: { action: 'paginate' | 'sort' | 'filter' },
  ) => void
  scroll?: { x?: number | string; y?: number | string }
  emptyText?: ReactNode
  className?: string
  style?: CSSProperties
  'data-testid'?: string
}

export function OmwTable<T>(props: OmwTableProps<T>) {
  return <HeadlessTable {...props} />
}
